import React, { useEffect } from "react";
import ReactGA4 from "react-ga4";

import portrait from "../../../assets/sdg.webp";

import Page from "../../common/page";

import "../../../styles/components/pages/generic-page.scss";
import "../../../styles/components/pages/meet-our-attorneys.scss";

function ShawnGarner() {
  useEffect(() => {
    ReactGA4.initialize(process.env.REACT_APP_GA4_PROPERTY_ID);
    ReactGA4.send("pageview");
  }, []);

  return (
    <Page
      selectedCategory="about"
      selectedLevel2="meetOurAttorneys"
      className="shawn-garner generic-page"
      title="Shawn D. Garner"
      description="Shawn D. Garner is partner of Deason Garner & Hansen Law Firm"
    >
      <div className="page-content">
        <h1>Shawn D. Garner</h1>
        <img src={portrait} alt="Shawn D. Garner, Attorney" />
        <p>
          Mr. Shawn Garner is the managing partner of{" "}
          <span className="fw-bold">Deason Garner & Hansen Law Firm</span> in{" "}
          <span className="fw-bold">Yuma, Arizona</span>. He attended the{" "}
          <span className="fw-bold">University of Kentucky Law School</span>.
          His work focuses on ensuring that individuals and families can protect
          their assets and plan for the future with legal clarity.
        </p>
        <p>
          The firm works exclusively in estate planning:{" "}
          <span className="fw-bold">Wills, Trusts, and Probate</span>. All its
          efforts are concentrated on establishing a plan for their clients or
          helping those inheriting an estate through the steps of receiving
          their inheritance.
        </p>

        <h2>Professional Journey</h2>
        <p>
          In the sun-kissed expanse of Yuma, Arizona, Shawn D. Garner stands as
          a managing partner of Deason Garner & Hansen Law Firm. His legal
          prowess shines brightest in the realms of Medicaid, Trusts, and
          Probate, guiding clients through the intricate maze of estate
          planning. Before anchoring his ship at this firm, he navigated the
          turbulent waters of commercial litigation and bankruptcy law, amassing
          a wealth of experience.
        </p>

        <h2>Educational Odyssey</h2>
        <p>
          Shawn's quest for knowledge led him to the University of Kentucky Law
          School, where he earned his Juris Doctorate in 2008. His academic
          journey began at Arizona Western College, followed by a stellar
          performance at Colorado State University, where he graduated in the
          top 1% with dual majors in Political Science and Criminal Justice.
        </p>

        <h2>Community Engagement</h2>
        <p>
          Beyond the courtroom, Shawn's voice resonates through public seminars,
          where he unravels the complexities of estate planning, trust, and
          long-term care benefits available through Medicaid. Each Sunday, he
          volunteers at the Arizona State Prison Complex, encouraging prisoners
          to change their lives through faith and an understanding of scripture.
        </p>

        <h2>Professional Affiliations</h2>
        <p>Shawn's professional tapestry is rich with affiliations:</p>
        <ul>
          <li className="fw-normal">
            Member of the Arizona State Bar Association, 2008
          </li>
          <li className="fw-normal">
            Admitted to practice in the Federal District Court of Arizona, 2008
          </li>
          <li className="fw-normal">
            Active participant in the Arizona Medicaid Planning Council 2013
          </li>
          <li className="fw-normal">
            National Academy of Elder Law Attorneys, Arizona Chapter (NAELA)
          </li>
          <ul>
            <li className="fw-normal">Member 2014</li>
            <li className="fw-normal">Secretary 2023-2024</li>
            <li className="fw-normal">Chair 2024-2025</li>
          </ul>
          <li className="fw-normal">
            Probate and Trust Executive Council for the State Bar of Arizona
            (PATEC)
          </li>
          <ul>
            <li className="fw-normal">Member 2018</li>
            <li className="fw-normal">Secretary 2021-2023</li>
            <li className="fw-normal">Vice Chair 2023-2024</li>
            <li className="fw-normal">Chair 2024-2025</li>
          </ul>
        </ul>
      </div>
    </Page>
  );
}

export default ShawnGarner;
